export default __webpack_public_path__ + "static/media/ALPHA-BNB.dcb4a43d.svg";